import React, { useEffect, useState } from 'react'
import { Button } from '@mui/material';
import axios from 'axios';
import { LoadingButton } from '@mui/lab';

const AICaller = () => {

    const [filesContent, setFilesContent] = useState({
        entrada: '',
        contexto: '',
        mensajeWhatsapp: '',
        mensajeAdvertencia: ''
    });

    const [loading, setLoading] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);

    const fetchFilesContent = async () => {
        try {
            const response = await axios.get('https://getaicallerfiles-5kg2vejuqa-uc.a.run.app');
            setFilesContent(response.data);
        } catch (error) {
            console.error('Error al obtener el contenido:', error);
        }
    };

    const handleContentChange = (content: any, field: string) => {
        let _content = content;
        switch (field) {
            case 'mensajeAdvertencia':
            case 'entrada':
                _content = _content.replace(/[\r\n\v]+/g, '');
                _content = _content.replace(/[^a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s.,!?´]/g, '');
                break;
            default:
                break;
        }
        setFilesContent({
            ...filesContent,
            [field]: _content
        });
        setHasChanges(true);
    };

    const saveFilesContent = async () => {
        setLoading(true);
        try {
            await axios.post('https://setaicallerfiles-5kg2vejuqa-uc.a.run.app', filesContent);
            alert('Contenido guardado exitosamente');
            setHasChanges(false);
        } catch (error) {
            console.error('Error al guardar el contenido:', error);
            alert('Error al guardar el contenido');
        } finally {
            setLoading(false);
        }
    };

    const callToNumber = async (phone: string) => {
        try {
            const response = await axios.post('https://makecall-5kg2vejuqa-uc.a.run.app', {
                to: phone,
                from: '+12566074845'
            });
            alert('Llamada iniciada');
        } catch (error) {
            alert('Ocurrió un error al iniciar la llamada');
            console.error('Error al obtener el contenido:', error);
        }
    }

    useEffect(() => {
        fetchFilesContent();
    }, []);

    return (
        <div className='shadow-md border rounded-2xl p-6 bg-white max-w-[800px]'>
            <div className='space-y-6'>
                <div className='font-bold text-2xl'>Agente de ventas por llamada</div>
                <div className='space-y-4'>
                    <div className='space-y-2'>
                        <div className='font-bold text-lg'>Mensaje de advertencia</div>
                        <div className='text-base'>Mensaje de advertencia que se le dará al usuario. No lo dice el agente.</div>
                        <div className='outline-none rounded-lg border border-gray-400 min-h-[100px] overflow-y-auto flex'>
                            <textarea
                                className='outline-none p-4 grow'
                                value={filesContent.mensajeAdvertencia}
                                onChange={e => handleContentChange(e.target.value, 'mensajeAdvertencia')}>

                            </textarea>
                        </div>
                    </div>
                    <div className='space-y-2'>
                        <div className='font-bold text-lg'>Mensaje inicial</div>
                        <div className='text-base'>Mensaje que dirá el agente al iniciar la llamada</div>
                        <div className='outline-none rounded-lg border border-gray-400 min-h-[100px] overflow-y-auto flex'>
                            <textarea
                                className='outline-none p-4 grow'
                                value={filesContent.entrada}
                                onChange={e => handleContentChange(e.target.value, 'entrada')}>

                            </textarea>
                        </div>
                    </div>
                    <div className='space-y-2'>
                        <div className='font-bold text-lg'>Mensaje de WhatsApp</div>
                        <div className='text-base'>El mensaje de WhatsApp está autorizado y verificado por Whatsapp Business. No se puede cambiar sin previo desarrollo personalizado y autorización necesaria por parte de WhatsApp Business.</div>
                        <Button
                        variant="outlined"
                        size="large"
                        onClick={() => {
                            window.open("https://console.twilio.com/us1/develop/sms/content-template-builder", "_blank");
                        }}
                    >
                        Ver los templates
                    </Button>
                    </div>
                    <div className='space-y-2'>
                        <div className='font-bold text-lg'>Perfil del agente</div>
                        <div className='text-base'>Instrucciones generales que debe seguir el agente</div>
                        <div className='outline-none rounded-lg border border-gray-400 min-h-[500px] overflow-y-auto flex'>
                            <textarea
                                className='outline-none p-4 grow'
                                value={filesContent.contexto}
                                onChange={e => handleContentChange(e.target.value, 'contexto')}>

                            </textarea>
                        </div>
                    </div>
                </div>
                <div className='flex flex-col justify-center space-y-2 desktop:space-y-0 desktop:flex-row desktop:justify-end desktop:space-x-2'>
                    <Button
                        variant="outlined"
                        size="large"
                        disabled={hasChanges}
                        onClick={() => {
                            const to = window.prompt("Ingresa el número completo");
                            if (to !== null && to !== "")
                                callToNumber(to);
                        }}
                    >
                        Hacer llamada de prueba
                    </Button>
                    <LoadingButton
                        loading={loading}
                        variant="contained"
                        size="large"
                        onClick={saveFilesContent} 
                        disabled={loading || hasChanges === false}
                    >
                        Guardar
                    </LoadingButton>
                </div>
            </div>
        </div>
    );
};


export { AICaller };